export default __webpack_public_path__ + "static/media/donw_aro.ed564fb0.svg";